/* eslint-disable indent,import/prefer-default-export */
import fr from 'facet-rest';
import PriorityButtonGroup from 'Components/UI/Overrides/PriorityButtonGroup';
import RichTextEditor from 'Components/UI/RichTextEditor';
import RichTextDisplay from 'Components/UI/Overrides/RichTextDisplay';
import TextField from 'Components/UI/TextField';
import Date from 'Components/UI/DateField';
import {
  _stringMetaFieldShowRemainingCharacters,
} from 'Components/UI/Meta/MetaControl/Types/String';

// TODO: Option ordering
const hiddenFieldNames = ['meetingId', 'calendarEventId', 'notApplicableDescription', 'status', 'showOnBlueprint', 'ownerId', 'householdId', 'clientId', 'timeToComplete', 'hidden'];

const agentHiddenFields = [
    'meetingId',
    'calendarEventId',
    'notApplicableDescription',
    'showOnBlueprint',
    'ownerId',
    'householdId',
    'clientId',
    'hidden',
];

export const ClientActionItemOverride = fr.metaOverride()
  .override({ readonly: true }, { hidden: true })
  .nameOverride(name => hiddenFieldNames.includes(name), { hidden: true })
  .nameOverride('name', {
    prompt: 'Title',
    label: 'Title',
    _component: () => TextField,
    _customProps: { multiline: true },
    display: true,
    hidden: false,
  })
  .nameOverride('priority', { _component: () => PriorityButtonGroup, display: true, hidden: false })
  .nameOverride('dueDate', { display: true, hidden: false })
  .nameOverride('description', { _component: () => RichTextEditor, display: true, hidden: false })
  .override(
    { readonly: true, name: 'description' },
    { _component: () => RichTextDisplay },
    { ordinal: 101 },
  )
  .override(
    { readonly: true, name: 'name' },
    {
      _component: () => TextField,
      _customProps: { disabled: true },
    },
    { ordinal: 101 },
  )
  .override(
    { readonly: true, name: 'priority' },
    {
      _formatReadOnly: () => attrValue => attrValue,
      _component: () => PriorityButtonGroup,
      _customProps: {
        showReadOnlyOptions: true,
        display: true,
        hidden: false,
        disabled: true,
      },
    },
    { ordinal: 101 },
  )
  .override(
    { readonly: true, name: 'dueDate' },
    {
      _component: () => Date,
      _customProps: { disabled: true },
    },
    { ordinal: 101 },
  );

const mobileHiddenFieldNames = ['assignedTo', ...hiddenFieldNames];
export const MobileClientActionItemOverride = fr.metaOverride()
  .override({ readonly: true }, { hidden: true })
  .nameOverride(mobileHiddenFieldNames, { hidden: true })
  .nameOverride('name', {
    prompt: 'Title',
    display: true,
    hidden: false,
    ordinal: 1,
    [_stringMetaFieldShowRemainingCharacters]: true,
  })
  .nameOverride('dueDate', {
    display: true,
    hidden: false,
    ordinal: 2,
  })
  .nameOverride('priority', {
    _component: () => PriorityButtonGroup,
    display: true,
    hidden: false,
    ordinal: 3,
  })
  .nameOverride('description', {
    _component: () => RichTextEditor,
    display: true,
    hidden: false,
    ordinal: 4,
    _customProps: {
      config: {
          toolbarGroups: [
            { name: 'document', groups: ['mode', 'document', 'doctools'] },
            { name: 'forms' },
            { name: 'basicstyles', groups: ['basicstyles', 'cleanup'] },
            {
              name: 'paragraph',
              groups: ['list', 'bidi'],
            },
            { name: 'links' },
            { name: 'styles' },
            { name: 'tools' },
          ],
          removePlugins:
            'resize,maximize,link,sourcearea,elementspath,scayt,contextmenu,liststyle,tabletools,tableselection,stylescombo,format,font,justify,removeformat',
      },
    },
  })
  .nameOverride('status', {
    display: true,
    hidden: false,
    ordinal: 5,
  })
  .override(
    { readonly: true, name: 'description' },
    { _component: () => RichTextDisplay },
    { ordinal: 101 },
  )
  .override(
    { readonly: true, name: 'name' },
    {
      _component: () => TextField,
      _customProps: { disabled: true },
    },
    { ordinal: 101 },
  )
  .override(
    { readonly: true, name: 'priority' },
    {
      _formatReadOnly: () => attrValue => attrValue,
      _component: () => PriorityButtonGroup,
      _customProps: {
        showReadOnlyOptions: true,
        display: true,
        hidden: false,
        disabled: true,
      },
    },
    { ordinal: 101 },
  )
  .override(
    { readonly: true, name: 'dueDate' },
    {
      _component: () => Date,
      _customProps: { disabled: true },
    },
    { ordinal: 101 },
  );

export const AgentActionItemOverride = fr.metaOverride()
    .override({ readonly: true }, { hidden: true })
    .nameOverride(name => agentHiddenFields.includes(name), { hidden: true })
    .nameOverride('priority', { _component: () => PriorityButtonGroup })
    .nameOverride('description', { _component: () => RichTextEditor });

export const AgentActionItemTableOverride = fr.metaOverride()
    .nameOverride(name => agentHiddenFields.includes(name), { hidden: true })
    .nameOverride('clientName', { ordinal: 1, readonly: true })
    .nameOverride(
        'name',
        {
            ordinal: 2,
            readonly: true,
            _component: () => TextField,
            _customProps: { disabled: true },
        },
)
    .nameOverride('ownerName', { ordinal: 2, readonly: true })
    .nameOverride('status', { ordinal: 3, readonly: true })
    .nameOverride('priority', { ordinal: 4, readonly: true })
    .nameOverride('dueDate', { ordinal: 5, readonly: true })
    .nameOverride('createdByName', { ordinal: 6 })
    .nameOverride('leadPlannerName', { ordinal: 7, readonly: true })
    .nameOverride('priority', { ordinal: 8, readonly: true, _component: () => PriorityButtonGroup })
    .nameOverride('description', { ordinal: 9, _component: () => RichTextDisplay })
    .nameOverride('timeToComplete', { ordinal: 10, readonly: true })
    .nameOverride('assignedTo', { ordinal: 11, readonly: true });

export const getActionItemFilters = (collection, householdSearch) => [
  {
    name: 'householdId', // picklist
    overrideOptions: householdSearch ? householdSearch.map(search => ({
      name: `${search.attributes.primaryClientFirstName} ${search.attributes.primaryClientLastName} [${search.id}]`,
      value: search.id.toString(),
    })) : [],
    query: 'getActionItems',
    _setQueryParam: true,
  },
  {
    name: 'assignedTo', // picklist
    query: 'getActionItems',
    prompt: 'Assigned To',
  },
  {
    name: 'ownerId', // picklist
    overrideOptions: collection
    .meta()
    .field('assignedTo')
    .options()
    .list()
    .map(option => ({
      name: option.attr('prompt'),
      value: option.attr('id'),
    })),
    query: 'getActionItems',
    prompt: 'Assigned To User',
  },
  {
    name: 'status', // multi-picklist
    query: 'getActionItems',
    overrideOperators: ['in'],
  },
  {
    name: 'priority', // multi-picklist
    query: 'getActionItems',
    overrideOperators: ['in'],
  },
  {
    name: 'leadPlannerName',
    query: 'getActionItems',
  },
  {
    name: 'createdByName', // string
    query: 'getActionItems',
  },
  {
    name: 'dueDateStart', // date
    query: 'getActionItems',
    overrideOperators: ['gte'],
  },
  {
    name: 'dueDateEnd', // date
    query: 'getActionItems',
    overrideOperators: ['lte'],
  },
];

export const defaultActionItemFilters = {
  householdId: {
    value: '',
  },
  assignedTo: {
    value: '',
  },
  status: {
    value: [
      'todo',
      'in-progress',
      'pending',
      'review',
      'completed',
    ],
  },
  priority: {
    value: ['low', 'medium', 'high'],
  },
};
